import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierList from '../components/lists/CarrierList';
import { useCarriers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminCarriersPage = ({ routes }) => {
  const { allCarriers } = useCarriers();

  return (
    <>
      <StickyPageHeader isAdmin title="Settings / Carriers" />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <CarrierList carriers={allCarriers} id="carriers" />
      </Layout>
    </>
  );
};

export default AdminCarriersPage;
